import AddRelationModal from './AddRelationModal';
import Split from '../Shared/Split';
import classNames from 'classnames';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { actions } from '../../context';
import { faCheck, faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { isGuidEmpty } from '../Forms/FinalFormValidation';
import { emptyGuid } from '../Shared/TextHelpers';
import { useHistory } from 'react-router-dom';

const relationsStyle = {
    minHeight: '100px',
    maxHeight: '500px',
    overflow: 'auto',
};
const status = {
    loading: false,
    searchingPractices: false,
    editingPractice: false,
    editingRelations: true,
};
const areOfferingsEqual = (newOfferingList, oldOfferingList) => {

    if(oldOfferingList.length !== newOfferingList.length) return false;

    const offeringEqualityCheck = (oldOffering) => {
        const compareOfferings = (newOffering) => {
            return newOffering.id === oldOffering.id
        };
        return newOfferingList.some(compareOfferings);
    };

    const comparedOfferings = !!oldOfferingList.length && oldOfferingList.every(offeringEqualityCheck);

    const isSameOfferingList = !!newOfferingList.length && comparedOfferings;

    return isSameOfferingList;
};

// TODO: this needs more refacotring than I am willing to do rn, very slow
const EditRelations = () => {

    let history = useHistory();

    const dispatch = useDispatch();
    const isOpen = useSelector((state) => state.practiceWorkflow.workFlowStatus.editingRelations);
    const practice = useSelector((state) => state.practiceWorkflow.workflowPractice, shallowEqual);
    const permissions = useSelector((state) => state.auth.permissions, shallowEqual);
    const addofferings = useSelector((state) => state.practice.relationsStep2, areOfferingsEqual);
    
    const [relations, setRelations] = useState([]);
    const [selectedRelation, setSelectedRelation] = useState();
    const [addingRelation, setAddingRelation] = useState(false);
    const [isFetchingData, setIsFetchingData] = useState(true);

    const toggleLoading = (loading) => {
        let isLoading = {...status, loading: loading, editingRelations: !loading};
        dispatch(actions.practiceWorkflow.setWorkflowStatus(isLoading)
    )};
    
    const togglePreviousStep = () => {
        let isEditing = {...status, editingPractice: true, editingRelations: false};
        dispatch(actions.practiceWorkflow.setWorkflowStatus(isEditing)
    )};

    const closeWorkflow = () => {
        dispatch(actions.practiceWorkflow.setWorkflowStatus({
            loading: false,
            searchingPractices: true,
            editingPractice: false,
            editingRelations: false,
        }));
        dispatch(actions.toggle.togglePracticeWorkflowModalOpen(false));
    };

    const finishWorkflow = () => {
        // validating if practice state (redux) come with value to be create/update it
        if(practice)
        {
            if (isGuidEmpty(practice?.id))
            {
                createPractice(practice, addofferings);
            }
            else 
            {
                editPractice(practice, addofferings);
            }
        }
    };

    const createPractice = (valuesToSubmit, offeringsToSubmit) => {
        toggleLoading(true);
        
        dispatch(actions.practice.createPractice(valuesToSubmit))
            .then((saveResult) => {
                let practiceId;
                dispatch(actions.practice.getPractice(saveResult, true))
                    .then((practiceResult) => {
                        practiceId = practiceResult.data.data.id;

                        //Saving Offering Relations
                        if (addofferings.length > 0)
                        {
                            saveOfferings(offeringsToSubmit, practiceId);
                        }
                })
                .then(() => {
                    dispatch(actions.toggle.triggerRefresh());
                    dispatch(actions.toggle.triggerPracticeRefresh());
                    history.push('/practices/' + practiceId);
                })
                .catch(error => {
                    dispatch(actions.toggle.triggerRefresh());
                    dispatch(actions.toggle.triggerPracticeRefresh());
                })
                .finally(() => {
                    toggleLoading(false)
                    closeWorkflow()
                })
            });
    };

    const editPractice = async (valuesToSubmit, offeringsToSubmit) => {
        let practiceId
        toggleLoading(true);

        dispatch(actions.practice.editPractice(valuesToSubmit))
        .then((saveResult) => {
            practiceId = saveResult.data

            //Saving Offering Relations
            if (offeringsToSubmit.length > 0) 
                saveOfferings(offeringsToSubmit, practiceId);
        })
        .then(() => {
            dispatch(actions.toggle.triggerRefresh());
            dispatch(actions.toggle.triggerPracticeRefresh());
        })
        .finally(() => {
            toggleLoading(false)
            history.push('/practices/' + practiceId);
            closeWorkflow()
        });
    };

    const saveOfferings = (offerings, practiceid) => {
        offerings.map((x) => 
             dispatch(actions.relations.saveRelation(
                practiceid, 
                x.partnerOfferingId, 
                x?.customPartnerId,
                x.convertAttachments
            ))
            .then(() => {
                dispatch(actions.toggle.triggerRefresh());
                dispatch(actions.toggle.triggerPracticeRefresh());
            })
        );
    };

    const refreshRelations = () =>{
        //exiting practice (Edit Mode)
        if (!isGuidEmpty(practice?.id)) 
        {
            if (!addofferings.length) {

                dispatch(actions.relations.getPracticeRelations(practice?.id))
                .then((res) => {
                    setRelations(res.data.data);
                    
                    //if the practice has relations we will update the relations state
                    if(res.data.data.length > 0) {
                        res.data.data.map((x) =>
                            dispatch(actions.practice.addOfferingStep2(x))
                        )
                    }
                })
                .finally(() => setIsFetchingData(false));
            }
        }
        setIsFetchingData(false);
    };

    useEffect(() => {
        if (isOpen) {
            refreshRelations();
        }
        // eslint-disable-next-line
    }, [dispatch]);

    const toggleAddingRelation = () => {
        if (addingRelation) setSelectedRelation();
        setAddingRelation(!addingRelation);
    };

    const editRelation = (relation) => {
        setSelectedRelation(relation);
        toggleAddingRelation();
    };

    const removeRelation = (relation) => {
        dispatch(actions.practice.removeOfferingsStep2(relation.partnerOfferingId));
    };

    return (
        <div className={classNames({ 'd-none': !isOpen })}>

            {addingRelation && (
                // TODO: refactor this modal to be more effcient, use primitives for props
                <AddRelationModal
                    isOpen={addingRelation}
                    practice={practice}
                    refresh={refreshRelations}
                    relations={relations}
                    relation={selectedRelation}
                    toggle={toggleAddingRelation}
                />
            )}

            <Split>
                <h4>Offerings</h4>
                <Button
                    color="primary"
                    className="border"
                    onClick={toggleAddingRelation}>
                    <FontAwesomeIcon icon={faPlus} size="lg" />
                </Button>
            </Split>
            {isFetchingData && (<div className="loading-spinner spin-animate mx-auto my-4"></div>)}
            {!isFetchingData && (
            <div
                className="d-flex flex-wrap justify-content-around p-1"
                style={relationsStyle}>
                {addofferings.length === 0 && (
                    <div className="text-center">
                        You have no active offerings for this practice
                        <br />
                        <br />
                        Click the '+' button to add an offering
                    </div>
                )}
                {addofferings.map((r) => (
                    <div
                        key={r.id}
                        className="rounded w-33 m-2 bg-light text-dark p-2">
                        <Split className="border-bottom border-secondary">
                            <div className="">
                                <h5>{r.name}</h5>
                                <span className="op-7 text-14">
                                    {r.partnerName}
                                </span>
                            </div>
                            {practice?.id !== emptyGuid ? (
                                <FontAwesomeIcon
                                    icon={faEdit}
                                    onClick={() => editRelation(r)}
                                    className="pop-hover"
                                    size="lg"
                                />
                            ) : (
                                <FontAwesomeIcon
                                icon={faTrash}
                                onClick={() => removeRelation(r)}
                                className="pop-hover"
                                size="lg"
                                />
                            )}
                        </Split>
                        <div className="p-2 text-center">
                            <div className="hide-overflow">
                                {r.customPartnerId && (
                                    <>Custom Partner Id: {r.customPartnerId}</>
                                )}
                            </div>
                            <div className="text-12 pt-3">
                                {r.isDaylightOffering && (
                                    <span className="mx-2 text-nowrap">
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp;&nbsp;Daylight
                                    </span>
                                )}
                                {r?.isConversionOffering && (
                                    <span className="mx-2 text-nowrap">
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp;&nbsp;Conversion
                                    </span>
                                )}
                                {r.convertAttachments && (
                                    <span className="mx-2 text-nowrap">
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp;&nbsp;Attachments
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            )}
            <Split>
                <Button
                    color="info"
                    onClick={togglePreviousStep}
                    className="border">
                    Back
                </Button>
                <Button
                    color="primary"
                    // TODO: put this in a variable and name it so this is easier to understand
                    disabled={
                        (permissions || []).indexOf('ViewAllPractices') ===
                            -1 && addofferings.length < 1
                    }
                    onClick={finishWorkflow}
                    className="border">
                    Finish
                </Button>
            </Split>
        </div>
    );
};
export default EditRelations;
